import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import { getFormCate, getMyApplyDetailsById, editMyApplyDetailsById, startProcess, deletFormFillById, queryMyBelowApplyOverList, getUserInfo, saveTask, handleNotice, handleFormApplyOver } from '@/services/myApply';
import selectPerson from '@/components/select-person/genera';
import { nextFlowNode, complete, saveFlowTrack, queryFormFillById } from '@/services/form';
var columns = [{
  title: '申请流水号',
  dataIndex: 'id',
  align: 'center',
  scopedSlots: {
    customRender: 'needId'
  },
  width: 50
}, {
  title: '标题',
  dataIndex: 'formName',
  scopedSlots: {
    customRender: 'formName'
  },
  width: 300
}, {
  title: '任务人',
  dataIndex: 'username',
  width: 100
}, {
  title: '办理状态',
  dataIndex: 'tkstatus',
  width: 50,
  scopedSlots: {
    customRender: 'tkstatus'
  }
}, {
  title: '办理意见',
  dataIndex: 'opinion',
  width: 200,
  scopedSlots: {
    customRender: 'opinion'
  }
}, {
  title: '操作人',
  width: 100,
  dataIndex: 'operUserName'
}, {
  title: '备注',
  width: 200,
  dataIndex: 'remark'
}, {
  title: '操作时间',
  width: 100,
  dataIndex: 'operTime'
}, {
  title: '操作',
  width: 50,
  scopedSlots: {
    customRender: 'operation'
  }
}];
var dataSource = [];
export default {
  watch: {
    // 优化监听逻辑
    userInfoList: {
      immediate: true,
      deep: true,
      handler: function handler(newVal) {
        this.filteruserInfoList = (newVal || []).filter(function (item) {
          return item && item.userName && item.userName.trim();
        });
      }
    }
  },
  name: 'myApplyMgr',
  components: {
    selectPerson: selectPerson
  },
  data: function data() {
    var _ref;
    var usersTabList = [{
      title: '组织',
      value: 0
    }, {
      title: '组织成员',
      value: 1
    }, {
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }, {
      title: '岗位成员',
      value: 5
    }];
    var userGroupTabList = [{
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }];
    return _ref = {
      userInfoList: [],
      //用户信息
      filteruserInfoList: [],
      // 筛选后的表单列表
      modalVisible: false,
      //模态框显示隐藏
      modalopinionVisible: false,
      //模态框显示隐藏
      newFormRecord: {
        //新增关联表单
        userId: '',
        needId: '',
        //关联表单流水号
        id: '',
        remark: '',
        opinion: ''
      },
      form1: {},
      userGroupTabList: userGroupTabList,
      userGroupObj: {},
      flowApproverSetList: [],
      visible: false,
      visibleId: '',
      loading: false,
      expand: false,
      usersList: {},
      usersTabList: usersTabList,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      timeValue: undefined,
      form: {
        formName: undefined,
        cateId: undefined,
        fillStatus: undefined,
        currentNo: 1,
        pageSize: 10,
        startDateTime: '',
        endDateTime: '',
        timeValue: undefined,
        summary: '',
        fillId: '',
        content: ''
      },
      fillStautsList: [{
        itemName: '待办',
        itemKey: 0
      }, {
        itemName: '已办',
        itemKey: 1
      }, {
        itemName: '待分配',
        itemKey: 2
      }],
      columns: columns,
      total: 0,
      dataSource: dataSource,
      selectedRows: [],
      cateList: [{
        cateId: 1,
        cateMemo: '',
        cateName: '行政',
        parentId: 0,
        sortNum: 1,
        status: 1,
        treeLevel: 0
      }]
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "visible", false), "confirmLoading", false), "pagination", this.$hdk.page()), "viewVisible", false), "formData", {
      list: [],
      config: {
        labelWidth: 100,
        labelPosition: 'right',
        size: 'small',
        customClass: '',
        ui: 'element',
        layout: 'horizontal',
        labelCol: 3,
        width: '100%',
        hideLabel: false,
        hideErrorMessage: false
      }
    }), "viewData", {
      input: 'input',
      text: 'text',
      radio: 'Option 1'
    }), "editData", {
      input: 'input',
      text: 'text',
      radio: 'Option 1'
    }), "editVisible", false), "editItem", {}), "auditUserVisible", false), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ref, "nextAuditUser", ''), "nextAuditUsers", []), "nextAuditUserFlag", false), "nextAuditUserType", ''), "nextAuditGroup", ''), "procInsId", ''), "formObject", {
      organPostId: []
    }), "options", []), "userInfo", this.$hdk.userInfo.get()), "rules", {
      organPostId: [{
        required: true,
        message: '请选择所属组织及岗位'
      }]
    }), _defineProperty(_ref, "needId", "");
  },
  methods: {
    // 获取状态颜色
    getStatusColor: function getStatusColor(tkstatus) {
      if (tkstatus === 0 || tkstatus === null || tkstatus === "") {
        if (tkstatus === 0) {
          return 'orange'; // 待办
        } else {
          return 'blue'; // 待分配
        }
      } else if (tkstatus === 1) {
        return 'green'; // 已办
      }
      return 'default';
    },
    // 获取状态文本
    getStatusText: function getStatusText(tkstatus) {
      if (tkstatus === 0) {
        return '待　办';
      } else if (tkstatus === null || tkstatus === "") {
        return '待分配';
      } else if (tkstatus === 1) {
        return '已　办';
      }
      return '未知';
    },
    //表格行点击事件
    rowClick: function rowClick(record, index) {
      var _this = this;
      return {
        on: {
          dblclick: function dblclick() {
            if (record.fillStatus == 0 || record.fillStatus == 4) {
              _this.$router.push({
                path: '/formReview/reviewCenter/processMain',
                query: {
                  item: JSON.stringify(record),
                  type: record.fillStatus == 4 ? 4 : 1 //4:被驳回, 1:正常草稿(已启动流程和未启动流程)
                }
              });
            } else {
              _this.$router.push({
                path: '/formReview/reviewCenter/viewProcess',
                query: {
                  procInsId: record.processInstanceId,
                  fillId: record.id,
                  fillStatus: record.fillStatus
                }
              });
            }
          }
        }
      };
    },
    dbTwoClick: function dbTwoClick(row) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: row.processInstanceId,
          fillId: row.id,
          fillStatus: row.fillStatus
        }
      });
    },
    handleVisibleChange: function handleVisibleChange(row) {},
    //保存表单
    saveRelatedForm: function saveRelatedForm() {
      var _this2 = this;
      this.$refs.addForm.validate(function (valid) {
        if (valid) {
          var param = {
            userId: _this2.newFormRecord.userId,
            needId: _this2.needId,
            remark: _this2.newFormRecord.remark
          };
          saveTask(param).then(function (res) {
            if (res.data.code == 200) {
              _this2.$message.success('分配成功');
              _this2.modalVisible = false;
            }
            _this2.onQueryMyApplyList();
          });
        }
      });
    },
    handleFormApply: function handleFormApply(text, record) {
      var _this3 = this;
      var params = {
        needId: text.id,
        userId: text.userid,
        remark: text.remark
      };
      handleNotice(params).then(function (res) {
        if (res.data.code == 200) {
          if (res.data.message != "success") {
            _this3.$message.warning(res.data.message);
          } else {
            _this3.$message.success('通知成功');
          }
        }
      });
    },
    handleFormApplyOver: function handleFormApplyOver(text, record) {
      this.needId = text.id;
      this.newFormRecord = {
        userId: '',
        needId: '',
        id: '',
        remark: '',
        opinion: ''
      }; // 重置表单
      this.modalopinionVisible = true; // 显示模态框   
    },
    handleSearch: function handleSearch(keyword) {
      var searchKey = keyword ? keyword.trim().toLowerCase() : '';
      if (!searchKey) {
        this.filteruserInfoList = (this.userInfoList || []).filter(function (item) {
          return item && item.userName && item.userName.trim();
        });
        return;
      }
      this.filteruserInfoList = (this.userInfoList || []).filter(function (item) {
        if (!item || !item.userName) return false;
        var userNameMatch = item.userName.toLowerCase().includes(searchKey);
        var userIdMatch = item.userId && item.userId.toString().includes(searchKey);
        return userNameMatch || userIdMatch;
      });
    },
    handlepopConfirmConfirm: function handlepopConfirmConfirm(row) {
      var _this4 = this;
      saveFlowTrack(row).then(function (res) {
        _this4.visible = false;
        _this4.onQueryMyApplyList();
      });
    },
    handlepopConfirmCancel: function handlepopConfirmCancel() {
      this.visible = false;
    },
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value) {
      var $set = this.$set,
        formObject = this.formObject;
      // 组织岗位赋值
      $set(formObject, 'organId', value[0]);
      $set(formObject, 'postId', value[1]);
      this.formObject.customize = {};
      this.formObject.customize.organId = value[0];
      this.formObject.customize.postId = value[1];
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    toSave: function toSave(row) {
      var _this5 = this;
      this.visible = false;
      this.visibleId = row.processInstanceId;
      if (row.trackStatus == 2) {
        this.visible = true;
      } else {
        this.visible = false;
        saveFlowTrack(row).then(function (res) {
          _this5.onQueryMyApplyList();
        });
      }
    },
    toggle: function toggle() {
      this.expand = !this.expand;
    },
    initDict: function initDict() {
      var that = this;
      getFormCate().then(function (res) {
        var list = res.data.data;
        that.cateList = list;
      });
    },
    queryTableList: function queryTableList() {
      sessionStorage.setItem('searchForm', JSON.stringify(this.form));
      this.form.currentNo = 1;
      this.pagination.current = 1;
      this.onQueryMyApplyList();
      sessionStorage.removeItem('Pagination_formTaskAllocation');
    },
    restForm: function restForm() {
      var $refs = this.$refs;
      sessionStorage.removeItem('searchForm');
      $refs.searchFrom.resetFields();
    },
    onQueryMyApplyList: function onQueryMyApplyList() {
      var _this6 = this;
      var pagination = this.pagination,
        form = this.form,
        pager = _.assign({}, pagination);
      this.loading = true;
      var searchForm = JSON.parse(sessionStorage.getItem('searchForm'));
      if (searchForm) {
        this.form = searchForm;
      }
      if (this.form.timeValue) {
        this.form.startDateTime = this.form.timeValue[0];
        this.form.endDateTime = this.form.timeValue[1];
      }
      this.form.currentNo = pager.current;
      this.form.pageSize = pager.pageSize;
      queryMyBelowApplyOverList(this.form).then(function (res) {
        var _res$data = res.data,
          code = _res$data.code,
          data = _res$data.data;
        if (code == 200) {
          _this6.dataSource = data && Object.prototype.hasOwnProperty.call(data, 'rows') ? data.rows : [];
          _this6.total = data && Object.prototype.hasOwnProperty.call(data, 'total') ? data.total : 0;
          _.assign(pagination, {
            total: _this6.total,
            current: pager.current,
            pageSize: pager.pageSize
          });
          _.assign(form, pager.form);
        }
      }).finally(function () {
        _this6.loading = false;
      });
      getUserInfo().then(function (res) {
        if (res.data.code == 200) {
          _this6.userInfoList = res.data.data;
        }
      });
    },
    onClickEdit: function onClickEdit(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/processMain',
        query: {
          item: JSON.stringify(record),
          type: record.fillStatus == 4 ? 4 : 1 //4:被驳回, 1:正常草稿(已启动流程和未启动流程)
        }
      });
      // console.log(JSON.stringify(record));
      // this.editItem = record;
      // this.usersList = {
      //     postData: [],
      //     organData: [],
      //     userData: []
      // };
      // getMyApplyDetailsById(record).then(res => {
      //     if (res.data.code === 200) {
      //         console.log('res', res.data.data);
      //         this.formData = JSON.parse(res.data.data.formData);
      //         this.editData = JSON.parse(res.data.data.fillData);
      //         this.editVisible = true;
      //         this.formObject.organPostId[0] = res.data.data.organId;
      //         this.formObject.organPostId[1] = res.data.data.postId;
      //         this.$nextTick(() => {
      //             console.log(this.formData, this.editData, '===================>formData1');
      //             this.$refs.editGenerateForm.refresh();
      //         });
      //     }
      // });
    },
    onClickPublish_back: function onClickPublish_back(text, record) {
      var _this7 = this;
      startProcess(text).then(function (res) {
        if (res.data.code === 200) {
          _this7.onQueryMyApplyList();
          _this7.$message.success('提交成功');
        }
      });
    },
    deleteInfo: function deleteInfo(text, record) {
      var _this8 = this;
      var $confirm = this.$confirm,
        $message = this.$message;
      $confirm("确认删除吗?", "提示", {
        type: "info",
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(function () {
        deletFormFillById({
          id: record.id
        }).then(function (res) {
          if (res.data.code == 200) {
            $message.success('删除成功');
          }
        });
        _this8.onQueryMyApplyList();
      }).catch(function () {});
    },
    onClickPublishThen: function onClickPublishThen(procInsId) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, param;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this9.procInsId = procInsId;
              _context.n = 1;
              return nextFlowNode({
                procInsId: _this9.procInsId
              });
            case 1:
              res = _context.v;
              if (res.data.code == 200) {
                param = {
                  procInsId: _this9.procInsId,
                  nextNodeCliamUserId: '',
                  nextNodeUserType: '',
                  comment: '发起流程申请',
                  processStatus: 1
                };
                if (res.data.data == undefined) {
                  _this9.completeTask(param);
                } else if (Object.keys(res.data.data).length > 0) {
                  if (res.data.message == '自由选择') {
                    _this9.auditUserVisible = true;
                    _this9.flowApproverSetList = res.data.data;
                  } else {
                    _this9.completeTask(param);
                  }
                }
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    onClickPublish: function onClickPublish(text) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              queryFormFillById({
                id: text.id
              }).then(function (res) {
                //查询流程是否启动
                var formFill = res.data.data;
                if (formFill != null && formFill.processInstanceId != null) {
                  //如果已经启动流程(还是草稿状态),则需要设置自由选择审批人

                  _this0.onClickPublishThen(formFill.processInstanceId);
                } else {
                  startProcess(_defineProperty(_defineProperty({
                    formName: text.formName,
                    fillId: text.fillId,
                    versionId: text.versionId,
                    fillData: text.fillData.value
                  }, "fillId", text.id), "formId", text.formId)).then(function (res) {
                    if (res.data.code == 200) {
                      // this.$message.success('提交成功')
                      _this0.onClickPublishThen(res.data.data);
                    }
                  });
                }
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    onMyApplyView: function onMyApplyView(record) {
      var _this1 = this;
      getMyApplyDetailsById(record).then(function (res) {
        if (res.data.code === 200) {
          _this1.formData = JSON.parse(res.data.data.formData);
          _this1.viewData = JSON.parse(res.data.data.fillData);
          _this1.viewVisible = true;
          _this1.$nextTick(function () {
            _this1.$refs.generateForm.refresh();
          });
        }
      });
    },
    onChange: function onChange(value, dateString) {},
    /*
     * 表格改变事件
     */
    onChangeTable: function onChangeTable(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      sessionStorage.setItem('Pagination_formTaskAllocation', JSON.stringify(this.pagination));
      this.onQueryMyApplyList();
    },
    onOk: function onOk(value) {},
    onViewClose: function onViewClose() {
      this.viewVisible = false;
    },
    onEditClose: function onEditClose() {
      this.editVisible = false;
    },
    handleSubmit: function handleSubmit() {
      var _this10 = this;
      var copyManData = new Array();
      this.$refs.editGenerateForm.getData().then(function (data) {
        editMyApplyDetailsById({
          id: _this10.editItem.id,
          fillData: data,
          fillId: _this10.editItem.fillId,
          versionId: _this10.editItem.versionId,
          copyManData: copyManData,
          organId: _this10.formObject.organPostId[0],
          postId: _this10.formObject.organPostId[1]
        }).then(function (res) {
          if (res.data.code == 200) {
            _this10.$message.success('保存成功');
            _this10.onEditClose();
          } else {
            _this10.$message.error(res.data.message);
          }
        });
      }).catch(function (e) {});
    },
    handleOk: function handleOk(e) {
      var _this11 = this;
      this.nextAuditUserFlag = true;
      this.flowApproverSetList.map(function (item) {
        var node = _this11.userGroupObj[item.taskDefKey];
        if (!node || JSON.stringify(node) == '{}' || node.postData.length == 0 && node.userData.length == 0) {
          _this11.$message.info('请选择节点: "' + item.taskName + '" 的审核人');
          _this11.nextAuditUserFlag = false;
        }
      });
      if (!this.nextAuditUserFlag) {
        return;
      }
      var param = {
        procInsId: this.procInsId,
        approverSetMap: this.userGroupObj,
        comment: '发起流程申请',
        processStatus: 1 //待审批
      };
      this.completeTask(param);
    },
    handleCancel: function handleCancel(e) {
      this.auditUserVisible = false;
    },
    handleNextAuditUserChange: function handleNextAuditUserChange(index) {
      this.nextAuditUser = this.nextAuditUsers[index].userId;
      this.nextAuditGroup = this.nextAuditUsers[index].levelRoleId;
    },
    completeTask: function completeTask(param) {
      var _this12 = this;
      complete(param).then(function (res) {
        if (res.data.code == 200) {
          _this12.$message.success('提交成功');
          _this12.auditUserVisible = false;
          _this12.onQueryMyApplyList();
          // this.$router.push({
          //     path: '/formReview/reviewCenter/viewProcess',
          //     query: { procInsId: this.procInsId }
          // })
        }
      });
    },
    loadData: function loadData() {
      this.onQueryMyApplyList();
    },
    restQuery: function restQuery() {
      this.form = {
        formName: '',
        cateId: '',
        fillStatus: '',
        currentNo: 1,
        pageSize: 10,
        startDateTime: '',
        endDateTime: ''
      };
      this.timeValue = undefined;
      this.loadData();
    },
    onViewWaitMeApply: function onViewWaitMeApply(text, record) {
      this.$router.push({
        path: '/formReview/reviewCenter/viewProcess',
        query: {
          procInsId: record.processInstanceId,
          fillId: record.id,
          fillStatus: record.fillStatus
        }
      });
    },
    //分配
    allocateFormApply: function allocateFormApply(text, record) {
      this.needId = text.id;
      this.newFormRecord = {
        userId: '',
        needId: '',
        id: '',
        remark: ''
      }; // 重置表单
      this.filteruserInfoList = _toConsumableArray(this.userInfoList); // 重置
      this.modalVisible = true; // 显示模态框   
    },
    //办结保存
    saveopinionRelatedForm: function saveopinionRelatedForm() {
      var _this13 = this;
      var param = {
        needId: this.needId,
        opinion: this.newFormRecord.opinion
      };
      handleFormApplyOver(param).then(function (res) {
        if (res.data.code == 200) {
          _this13.$message.success('办结成功');
          _this13.modalopinionVisible = false; // 关闭模态框
          _this13.onQueryMyApplyList();
        }
      });
    }
  },
  initDict: function initDict() {
    var _this14 = this;
    getDictList('form_cate').then(function (res) {
      if (res.data.code == 200) {
        _this14.dictList = res.data.data;
      }
    });
  },
  onSearch: function onSearch() {
    this.loadData();
  },
  onQueryMyApplyList: function onQueryMyApplyList() {
    this.loading = true;
    var params = _objectSpread(_objectSpread({}, this.form), {}, {
      startDateTime: this.timeValue ? this.timeValue[0] : '',
      endDateTime: this.timeValue ? this.timeValue[1] : ''
    });
    queryMyApplyList(params).then;
  },
  mounted: function mounted() {
    this.initDict();
    var savedPagination = sessionStorage.getItem('Pagination_formTaskAllocation');
    if (savedPagination) {
      try {
        var parsed = JSON.parse(savedPagination);
        this.pagination.current = parsed.current || 1;
        this.pagination.pageSize = parsed.pageSize || 10;
      } catch (e) {} finally {}
    }
    this.loadData();
  },
  created: function created() {
    var userInfo = this.userInfo;
    // 级联数据处理
    this.options = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        children: item.postList
      };
    });
  }
};